"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageModal = void 0;
const react_1 = __importStar(require("react"));
const theme_1 = require("../../../theme");
const buttons_1 = require("../../buttons");
const global_1 = require("../../global");
const MessageModal_styles_1 = require("./MessageModal.styles");
const MessageModal = (props) => {
    const { message, description, closeLabel, confirmLabel, showConfirmButton, onConfirm, close } = props;
    (0, react_1.useEffect)(() => {
        const handleKeyDown = ({ key }) => {
            if (key === "Escape" || key === "Esc") {
                close();
            }
        };
        window.addEventListener("keydown", handleKeyDown, true);
        return () => {
            window.removeEventListener("keydown", handleKeyDown, true);
        };
    }, [close]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MessageModal_styles_1.ModalBackgroundWrapper, null),
        react_1.default.createElement(MessageModal_styles_1.ModalWrapper, null,
            react_1.default.createElement(MessageModal_styles_1.ModalContentWrapper, null,
                react_1.default.createElement(MessageModal_styles_1.IconContainer, null,
                    react_1.default.createElement(global_1.IconWrapper, { hoverEffect: true, onClick: close },
                        react_1.default.createElement(theme_1.Close, null))),
                react_1.default.createElement(MessageModal_styles_1.ModalBodyContainer, null,
                    react_1.default.createElement(MessageModal_styles_1.Title, null, message),
                    react_1.default.createElement(MessageModal_styles_1.DescriptionWrapper, null, description),
                    react_1.default.createElement(MessageModal_styles_1.ButtonsWrapper, null,
                        showConfirmButton && onConfirm && (react_1.default.createElement(buttons_1.Button, { label: confirmLabel, type: "button", onClick: onConfirm })),
                        react_1.default.createElement(MessageModal_styles_1.CloseButtonWrapper, null,
                            react_1.default.createElement(buttons_1.Button, { label: closeLabel, type: "button", onClick: close }))))))));
};
exports.MessageModal = MessageModal;
//# sourceMappingURL=MessageModal.js.map